import uniqBy from 'lodash/uniqBy';
import genererGuid from '@/services/general/genererGuid';

function formatData(data) {
  return {
    data,
    id: data.id || data.num,
    libelle: data.nomCommercial || data.libelle,
    children: [],
    selected: false,
    openSecteur: false,
  };
}

function compare(a, b) {
  if (a.libelle.toLowerCase() < b.libelle.toLowerCase()){
    return -1;
  }
  if (a.libelle.toLowerCase() > b.libelle.toLowerCase()){
    return 1;
  }
  return 0;
}

export default function formatageConcurrents(pdvs, secteursActivites, secteurActiviteId) {
  const data = [];
  const pdvsFormat = pdvs.map(p => {
    return {
      id: p.num,
      secteurActiviteId: p.tiersParent && p.tiersParent.secteurActiviteId ? p.tiersParent.secteurActiviteId : p.secteurActiviteId,
      marque: p.tiersParent && p.tiersParent.marque ? p.tiersParent.marque : p.marque,
      libelle: p.nomCommercial,
      coordonnees: {
        lat: p.latitude,
        lng: p.longitude,
      },
      urlLogo: p.urlLogo,
    };
  }).filter(p => p.secteurActiviteId);

  secteursActivites.forEach(secteur => {
    const pdvsSecteur = pdvsFormat.filter(p => p.secteurActiviteId === secteur.id);

    const marques = uniqBy(pdvsSecteur.filter(p => p.marque && p.marque !== '')
      .map(p => ({ libelle: p.marque.trim(), id: genererGuid() })), 'libelle')
      .map(formatData).sort(compare);
    marques.forEach(marque => {
      marque.children = pdvsSecteur
        .filter(p =>  p.marque && p.marque !== '' && p.marque.trim() === marque.libelle)
        .map(formatData)
        .sort(compare);
    });
    
    const pdvsWithoutMarque = pdvsSecteur.filter(p => !p.marque)
      .map(formatData)
      .map(p => ({ ...p, isPdv: true }))
      .sort(compare);

    data.push({
      ...formatData(secteur),
      children: [...marques, ...pdvsWithoutMarque]
    });
  });
  const dataSort = data.filter(el => el.children.length).sort(compare);
  if (secteurActiviteId) {
    const index = dataSort.findIndex(el => el.id === secteurActiviteId);
    if (index !== -1) {
      const currentSecteur = dataSort[index];
      currentSecteur.selected = true;
      currentSecteur.openSecteur = true;
      currentSecteur.children.forEach(el => {
        el.selected = true;
        el.children.forEach(c => {
          c.selected = true;
        })
      })
      dataSort.splice(index, 1);
      dataSort.unshift(currentSecteur);
    }
  }
  return dataSort;
}
